import HttpRequest from './http_request'

class ConfigProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL)
  }

  //===========================================================================
  async getTeachTableShow({
    level_id = 1,
    mode,

    selected_year,
    selected_semester,

    selected_faculty,
    selected_department,
    selected_curriculum,
    selected_branch,
    selected_class_year,

    search_all_faculty,
    search_all_department,
    search_all_curriculum,
    search_all_branch,
    search_all_class_year,

    selected_subject_id,
    selected_subject_name,
    selected_subject_owner_id,

    selected_admission_type,
    selected_admission_semester,

    teacher_dept, }) {
    const { data } = await this.get('/', {
      function: 'get-teach-table-show',

      level_id: level_id,

      mode: mode,

      selected_year: selected_year,
      selected_semester: selected_semester,

      selected_faculty: selected_faculty,
      selected_department: selected_department,
      selected_curriculum: selected_curriculum,
      selected_branch: selected_branch,
      selected_class_year: selected_class_year,

      search_all_faculty: search_all_faculty,
      search_all_department: search_all_department,
      search_all_curriculum: search_all_curriculum,
      search_all_branch: search_all_branch,
      search_all_class_year: search_all_class_year,

      selected_subject_id: selected_subject_id,
      selected_subject_name: selected_subject_name,
      selected_subject_owner_id: selected_subject_owner_id,

      selected_admission_type: selected_admission_type,
      selected_admission_semester: selected_admission_semester,

      teacher_dept: teacher_dept,
    })
    return data
  }

  async closeTeachTable({ teach_table_id, level_id = 1 }) {
    const { data } = await this.delete('/', {
      function: Number(level_id) === 2 ? 'close-graduate-teach-table' : 'close-teach-table',
      teach_table_id: teach_table_id,
    })
    return data
  }

  async deleteTeachTable({ teach_table_id, level_id = 1 }) {
    const { data } = await this.delete('/', {
      function: Number(level_id) === 2 ? 'delete-graduate-teach-table' : 'delete-teach-table',
      teach_table_id: teach_table_id,
    })
    return data
  }

  async getTeacherSubject(teach_table_id, level_id = 1) {
    const { data } = await this.get('/', {
      function: 'get-teacher-subject',
      TEACH_TABLE_ID: teach_table_id,
      level_id,
    })
    return data
  }

  async deleteTeacher(year, semester, subject_id, section, teacher_id, level_id = 1, teach_table_id = null) {
    const { data } = await this.delete('/', {
      function: 'delete-teacher',
      year,
      semester,
      subject_id,
      section,
      teacher_id,
      level_id,
      teach_table_id,
    })
    return data
  }

  async getTeacherData() {
    const { data } = await this.get('/', {
      function: 'get-teacher-data'

    })
    return data
  }

  async addTeacher(teach_table_id, teacher_id, priority, level_id = 1) {
    const { data } = await this.post('/', {
      function: 'add-teacher',
      teach_table_id,
      teacher_id,
      priority,
      level_id,

    })
    return data
  }

  async getPracticeSectionPair(subject_id, year, semester) {
    const { data } = await this.get('/', {
      function: 'get-practice-section-pair',
      subject_id, year, semester
    })
    return data
  }

  async setPracticeSectionPair(TEACH_TABLE_ID, section_pair) {
    const { data } = await this.update('/', {
      function: 'set-practice-section-pair',
      TEACH_TABLE_ID, section_pair
    })
    return data
  }

  async getTeachTableConfigDateTime() {
    const { data } = await this.get('/', {
      function: 'get-teach-table-config-date-time'
    })
    return data
  }
}

export default ConfigProvider
